import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class ExpertContractsService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/expert-contracts`;
  
  async getAllExpertContracts(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<{ contracts: any[], count: number }> {
    return this.getAll(page, limit, order, filter);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<{
    contracts: any[], count: number
  }>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get<{ contracts: any[], count: number }>(`${this.url}`, { params: params }).toPromise() );
  }
}
